import React from "react";
import AppShell from "@/components/AppShell";
import { Lightning, ArrowSquareOut, Check, GoogleChromeLogo } from "@phosphor-icons/react";
import { CHROME_STORE_URL } from "@/lib/extensionConstants";

export default function ExtensionPage() {

  return (
    <AppShell title="Estensione Chrome" breadcrumb="Estensione Chrome">
        <div className="flex items-start gap-4 mb-10">
          <div className="hidden sm:flex w-14 h-14 items-center justify-center bg-[#7C8B6E] text-[#FFFFFF]">
            <Lightning size={26} weight="duotone" />
          </div>
          <div>
            <p className="text-xs uppercase tracking-[0.2em] text-[#6B6A65] mb-2">Estensione Chrome</p>
            <h1 className="font-editorial text-4xl lg:text-5xl tracking-tighter leading-[1.05] text-[#1C1C1A]">
              Pubblica con<br/>
              <span className="italic-accent text-[#7C8B6E]">un click<span className="not-italic text-[#7C8B6E]">.</span></span>
            </h1>
            <p className="mt-4 text-[#6B6A65] max-w-xl leading-relaxed">
              Pronto Publisher <strong className="text-[#1C1C1A]">ti aiuta a compilare</strong> i form di
              <strong className="text-[#1C1C1A]"> Immobiliare.it</strong> e
              <strong className="text-[#1C1C1A]"> Idealista</strong> (vendita o affitto).
              Riempie da solo i campi che riesce a mappare in automatico — titolo, descrizione,
              prezzo, m², locali, indirizzo, classe energetica, telefono — e tiene un
              <strong className="text-[#1C1C1A]"> pannello a destra con tutti i dati dell'annuncio</strong> sempre
              sotto mano: i campi che il portale chiede in modo proprietario (foto, planimetria,
              menu a tendina rari, sezioni custom) li copi-incolli a vista, senza cambiare scheda.
            </p>
          </div>
        </div>

        {/* iter v28 r396 — User M1306: «lasciala solo l'ufficiale, la provo
            anche se è ufficiale». Sostituito tutto il flusso "scarica zip →
            modalità sviluppatore → carica non pacchettizzata" con il singolo
            CTA verso lo Chrome Web Store. La guida manuale resta solo come
            fallback nascosto per chi ha problemi di connessione allo Store. */}
        <div className="mb-8 p-6 bg-[#F1F4ED] border border-[#7C8B6E]/30 rounded-2xl flex items-start gap-4">
          <div className="w-12 h-12 rounded-full bg-white border border-[#7C8B6E]/30 flex items-center justify-center flex-shrink-0">
            <GoogleChromeLogo size={26} weight="fill" className="text-[#7C8B6E]" />
          </div>
          <div className="flex-1 min-w-0">
            <h3 className="font-editorial text-xl text-[#1C1C1A] mb-1">Installa dallo Chrome Web Store</h3>
            <p className="text-[13px] text-[#6B6A65] leading-relaxed mb-3">
              Installazione ufficiale in 3 click · aggiornamenti automatici · verificata Google.
              Funziona su <strong>Chrome, Edge, Brave, Opera</strong>.
            </p>
            <a
              href={CHROME_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 bg-[#1C1C1A] hover:bg-black text-white text-sm font-semibold px-5 py-2.5 rounded-full transition-colors"
              data-testid="open-chrome-store-btn"
            >
              <GoogleChromeLogo size={16} weight="fill" />
              Aggiungi a Chrome
              <ArrowSquareOut size={13} weight="bold" />
            </a>
          </div>
        </div>

        {/* Step 1 — install dallo Store */}
        <Step
          n={1}
          done={false}
          title="Apri lo Chrome Web Store"
          desc={
            <p className="text-[#6B6A65]">
              Clicca il pulsante qui sopra <strong>"Aggiungi a Chrome"</strong>. Si apre la pagina
              ufficiale di Pronto Publisher su Google Web Store. Chrome verificherà
              automaticamente l'integrità dell'estensione.
            </p>
          }
          action={
            <a
              href={CHROME_STORE_URL}
              target="_blank"
              rel="noopener noreferrer"
              className="btn-primary"
              data-testid="step1-store-btn"
            >
              <GoogleChromeLogo size={16} weight="fill" /> Apri Chrome Web Store
            </a>
          }
        />

        {/* Step 2 — conferma installazione */}
        <Step
          n={2}
          done={false}
          title="Conferma 'Aggiungi a Chrome'"
          desc={
            <p className="text-[#6B6A65]">
              Sulla pagina dello Store clicca il bottone blu <strong>"Aggiungi a Chrome"</strong> in alto a destra.
              Una finestra di Chrome ti chiederà conferma · clicca <strong>"Aggiungi estensione"</strong>.
              In 2 secondi vedrai un pop-up "Pronto Publisher aggiunta a Chrome".
              Pinna l'icona <strong>"P"</strong> nella barra di Chrome (puzzle in alto a destra → spilla "Pronto Publisher").
            </p>
          }
        />

        {/* Step 3 — use */}
        <Step
          n={3}
          done={false}
          title="Pubblica un annuncio"
          desc={
            <ol className="space-y-2 list-decimal pl-5 text-[#6B6A65]">
              <li>Apri il portale dove vuoi pubblicare (Idealista o Immobiliare.it) e fai login.</li>
              <li>Avvia un <strong>nuovo annuncio</strong> sul portale.</li>
              <li>Clicca l'icona Pronto nella barra di Chrome → accedi con la tua email Pronto.</li>
              <li>Scegli l'immobile da pubblicare: Pronto <strong>aiuta a compilare</strong> i campi che riesce a mappare in automatico.</li>
              <li>Nel <strong>pannello a destra</strong> hai tutti i dati dell'annuncio sotto mano: i campi che il portale gestisce in modo proprietario (foto, planimetria, alcuni menu rari) li copi-incolli a vista, senza cambiare scheda.</li>
              <li>Controlla i campi, completa quelli rimasti vuoti, clicca <strong>Pubblica</strong> sul portale.</li>
            </ol>
          }
          action={
            <a
              href="https://www.idealista.it/info/pubblica-annuncio"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-outline"
              data-testid="open-idealista-btn"
            >
              <ArrowSquareOut size={16} weight="bold" /> Apri Idealista
            </a>
          }
        />

        {/* FAQ */}
        <div className="mt-16 pt-10 border-t border-[#E5E7E0]">
          <h2 className="font-editorial text-2xl tracking-tight mb-6">Domande frequenti</h2>
          <Faq q="È sicura?" a="Sì. L'estensione è pubblicata sullo Chrome Web Store ufficiale e verificata da Google. Comunica solo con i server di Pronto e non invia mai i tuoi dati ai portali oltre a quello che inserisci nel form." />
          <Faq q="Compila proprio tutto?" a="No, è onesto dirlo: alcuni campi proprietari dei portali (foto, planimetria, certi menu rari) non si possono iniettare via estensione. Pronto compila quello che riesce e tiene il pannello dati a destra come riferimento, così non devi più cambiare scheda per cercare le info dell'annuncio." />
          <Faq q="Funziona su Safari?" a="Per ora solo Chrome (e i browser basati su Chrome: Edge, Brave, Opera). Una versione Firefox è in arrivo." />
          <Faq q="Funziona anche per gli affitti?" a="Sì. L'estensione riconosce automaticamente se l'annuncio Pronto è in vendita o in affitto e adatta i campi: canone mensile, cauzione (in mensilità), tipologia di affitto (Idealista), arredamento, animali ammessi." />
          <Faq q="Posso modificare i campi prima di pubblicare?" a="Sì. Pronto compila il form ma puoi aggiustare ogni campo prima di cliccare 'Pubblica' sul portale." />
          <Faq q="Quali portali sono supportati?" a="Immobiliare.it e Idealista. Coprono oltre l'85% del mercato annunci immobiliari in Italia." />
          <Faq q="L'icona è grigia / non risponde" a="L'icona è sempre attiva, ma il pannello laterale compare solo sui domini supportati (immobiliare.it, idealista.it). Vai prima sul portale, fai login, e poi torna sull'icona Pronto per scegliere l'immobile." />
          <Faq q="Come ricevo gli aggiornamenti?" a="Lo Chrome Web Store aggiorna Pronto Publisher in automatico ogni volta che pubblichiamo una nuova versione. Non devi fare nulla." />
        </div>
      </AppShell>
  );
}

function Step({ n, done, title, desc, action }) {
  return (
    <div
      className={`mb-4 border p-6 transition-colors ${
        done ? "border-[#7C8B6E]/40 bg-[#F1F4ED]" : "border-[#E5E7E0] bg-white"
      }`}
      data-testid={`extension-step-${n}`}
    >
      <div className="flex items-start gap-4">
        <div
          className={`w-9 h-9 flex items-center justify-center text-sm font-medium flex-shrink-0 ${
            done ? "bg-[#7C8B6E] text-[#FFFFFF]" : "bg-[#F1F4ED] text-[#7C8B6E]"
          }`}
        >
          {done ? <Check size={16} weight="bold" /> : n}
        </div>
        <div className="flex-1">
          <h3 className="font-editorial text-xl tracking-tight">{title}</h3>
          <div className="mt-2 text-sm leading-relaxed text-[#6B6A65]">{desc}</div>
        </div>
      </div>
      {action && <div className="mt-4 ml-13 sm:ml-0 sm:pl-13">{action}</div>}
    </div>
  );
}

function Faq({ q, a }) {
  return (
    <details className="border-b border-[#E5E7E0] py-4 group">
      <summary className="cursor-pointer font-medium text-[#1C1C1A] flex items-center justify-between">
        {q}
        <span className="text-[#6B6A65] group-open:rotate-45 transition-transform text-2xl leading-none">+</span>
      </summary>
      <p className="mt-3 text-sm text-[#6B6A65] leading-relaxed">{a}</p>
    </details>
  );
}
